import { RecurringIntervalType } from "../../../../annualWheel/AnnualWheel.types";
import { ActivityFormModel } from "../../../../annualWheel/activityForm/ActivityFormModel";

export interface ObligationSuggestionViewModel {
    name: string;
    description?: string;
    section?: string;
    clause: string;
    /** False when the clause could not be found in the document, so the previewer will not highlight it. */
    clauseLocated: boolean;
    pageNumber?: number;
    recurringIntervalType?: RecurringIntervalType;
    interval?: number;
    duplicateMatch: ObligationDuplicateMatch;
}

/**
 * Why a suggestion looks like an obligation the contract already has. The two are not equally
 * trustworthy: the same quoted passage really is the same duty, whereas obligation names are short
 * imperatives that collide easily.
 */
export enum ObligationDuplicateMatch {
    None = 0,
    Clause = 1,
    Name = 2,
}

export interface ObligationExtractionResultViewModel {
    contractDocumentId: string;
    documentVersionId: string;
    suggestions: Array<ObligationSuggestionViewModel>;
}

/** One page of the review panel: the suggestion plus the editable obligation it seeded. */
export interface ObligationSuggestionPage {
    suggestion: ObligationSuggestionViewModel;
    model: ActivityFormModel;
    /**
     * True once the user pointed at the clause in the document themselves, which makes it locatable again
     * whatever the original verdict was.
     */
    clauseReplaced: boolean;
    excluded: boolean;
    showError: boolean;
    created: boolean;
}

/**
 * Derived per page, never stored. "untouched" and "needsAttention" are the same underlying problem - the
 * obligation is incomplete - and differ only in whether the user has already walked away from it once.
 * Nothing is red until they have.
 */
export type ObligationPageStatus = "untouched" | "needsAttention" | "ready" | "excluded" | "created";

export interface ObligationCreationProgress {
    isCreating: boolean;
    createdCount: number;
    totalCount: number;
    failedPageIndex?: number;
}
